import queryString from "query-string";
import { ConfigProvider, App as AntdApp } from "antd";
import {
  legacyLogicalPropertiesTransformer,
  StyleProvider,
} from "@ant-design/cssinjs";
import { useEffect, useState } from "react";
import Router from "./router";
import System from "@/store/system";
import { useTranslation } from "react-i18next";
import sensecommon from "@sensechat/user-inteceptor";
import SJLayout from "@/components/SJLayout";
import globalConf from "@/store/globalConf";
import authVM from "logic/src/businesses/auth/vm";
import useTraceLog from "logic/src/tracelog/useTraceLog";
import AIContentNoticeDialog from "@/components/AIContentNoticeDialog";
import { shouldShowAINotice, markAINoticeShown } from "@/utils/aiNoticeUtils";
// localStorage.setItem("moe", "true");

const App = () => {
  const { t } = useTranslation();
  // const [iframeLoaded, setIframeLoaded] = useState(false);
  const [isReady, setIsReady] = useState<boolean>(false);
  const [showAINotice, setShowAINotice] = useState<boolean>(false);
  useTraceLog();

  // if (System.isPad || System.isMobile) {
  //   if (window && window.location && window.location.href) {
  //     const { search, pathname } = window.location;
  //     if (pathname.indexOf("policyForApp") > -1) {
  //       const { id } = queryString.parse(search);
  //       if (id === "1") window.location.href = "/userPrivacyAgree";
  //       if (id === "2") window.location.href = "/infoCollectAgree";
  //     }
  //     else {
  //       window.location.href = "/mbs/";
  //     }
  //   }
  //   return (
  //     <div
  //       style={{
  //         width: "100%",
  //         height: "100vh",
  //         display: "flex",
  //         justifyContent: "center",
  //         alignItems: "center",
  //         color: "#333333",
  //         fontSize: "1.5rem",
  //       }}
  //     >
  //       {
  //         t("sensechat-262") // 加载中...
  //       }
  //     </div>
  //   );
  // }

  const initApp = async () => {
    sensecommon.init({
      // env: BUSINESS_ENV,
    });
    await Promise.all([globalConf.updateGlobalConf(), authVM.init()]);
    setIsReady(true);

    console.log("shouldShowAINotice", shouldShowAINotice());

    // 检查是否需要显示AI内容标识公告
    if (shouldShowAINotice()) {
      setShowAINotice(true);
    }
  };

  const handleAINoticeClose = () => {
    setShowAINotice(false);
    markAINoticeShown();
  };

  useEffect(() => {
    initApp();
  }, []);

  return (
    <StyleProvider
      hashPriority="high"
      transformers={[legacyLogicalPropertiesTransformer]}
    >
      <ConfigProvider
        theme={{
          components: {
            Button: {},
            Input: {},
            Segmented: {},
          },

          token: {
            colorPrimary: "#5D63C5",
            controlHeight: 40,
            colorLink: "#5D63C5",
            colorInfo: "#5D63C5",
            colorError: "#f66",
          },
        }}
      >
        <AntdApp style={{ width: "100%" }}>
          <SJLayout>{isReady ? <Router /> : false}</SJLayout>
          <AIContentNoticeDialog
            visible={showAINotice}
            onClose={handleAINoticeClose}
          />
        </AntdApp>
      </ConfigProvider>
    </StyleProvider>
  );
};

export default App;
